import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Band, PullQuote } from './Band';
import { candidateFacts, compliancePoints, neverCaptured } from '../../data/site';
export function Compliance() {
  return <Band id="compliance" eyebrow="Compliance" title="Designed for the audit before it happens." description="Automated scoring of instrumented behaviour, used in an employment decision, is the most regulated category of software going. The architecture assumes that from the start." aside={<PullQuote data-id="element-27" data-mp="1ya36aeyjuqbz">
          We never claim compliance with a regulation. We produce the
          documentation the regulation asks for.
        </PullQuote>} data-id="element-26" data-mp="10muhob39515r">
      <ul className="grid gap-px overflow-hidden rounded-2xl border border-mist bg-mist md:grid-cols-2 lg:grid-cols-3" data-id="element-28" data-mp="1jedm8mcxcn9w">
        {compliancePoints.map(point => <li key={point.tag} className="bg-bone p-7" data-id="element-29" data-mp="7w2pdopb4wnp">
            <span className="font-mono text-xs uppercase tracking-[0.14em] text-teal" data-id="element-30" data-mp="7zgpeqai0trz">
              {point.tag}
            </span>
            <p className="mt-3 max-w-[42ch] text-[15px] leading-relaxed text-graphite" data-id="element-31" data-mp="15lpdy9lvai8j">
              {point.body}
            </p>
          </li>)}
        <li className="bg-white/70 p-7" data-id="element-32" data-mp="10p8p1d6ufzue">
          <span className="font-mono text-xs uppercase tracking-[0.14em] text-clay" data-id="element-33" data-mp="1enovr44phqcj">
            Language discipline
          </span>
          <p className="mt-3 max-w-[42ch] text-[15px] leading-relaxed text-ink" data-id="element-34" data-mp="19nazejcgw4uc">
            Every artificial constraint maps to something a real practitioner
            faces. The documented framing is discriminating power on
            job-relevant dimensions, and it holds up under a bias audit.
          </p>
        </li>
      </ul>

      <div id="candidates" className="mt-6 scroll-mt-24 rounded-2xl border border-mist bg-white/60 p-8" data-id="element-35" data-mp="1xfhnkv81h5io">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-36" data-mp="27bugvrzo9hcw">
          What candidates are told
        </h3>
        <ul className="mt-6 grid gap-x-10 gap-y-3 lg:grid-cols-2" data-id="element-37" data-mp="22dj8zmsxtgxb">
          {candidateFacts.map(fact => <li key={fact} className="flex items-start gap-2.5 border-b border-mist/70 pb-3" data-id="element-38" data-mp="1004ueu1ff0i8">
              <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-39" data-mp="140fch52hthdg" />
              <span className="text-[15px] leading-snug text-ink" data-id="element-40" data-mp="1909zuyn27otr">{fact}</span>
            </li>)}
        </ul>
        <p className="mt-5 text-sm leading-relaxed text-muted" data-id="element-41" data-mp="1dra1gh74iv2l">
          Nothing about the session depends on the candidate not knowing how it
          works.
        </p>
      </div>

      <div className="mt-6 rounded-2xl border border-mist bg-white/60 p-8" data-id="element-42" data-mp="1noo2b8gkdb9s">
        <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-graphite" data-id="element-43" data-mp="1nqr38nj98ota">
          Never captured
        </h3>
        <ul className="mt-6 flex flex-wrap gap-3" data-id="element-44" data-mp="1wpcj2axcdpqd">
          {neverCaptured.map(item => <li key={item} className="inline-flex items-center gap-2 rounded-full border border-mist bg-bone px-4 py-2 text-[15px] text-ink" data-id="element-45" data-mp="1wn8hhzmx12t9">
              <XIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-46" data-mp="2as3udrsimed" />
              {item}
            </li>)}
        </ul>
      </div>
    </Band>;
}